import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { publicService } from '../services/publicService';
import SchedulingFlow, { SchedulingApi } from '../components/scheduling/SchedulingFlow';

/**
 * Public self-scheduling page (in-app, Yoman-backed) — booked by patient uuid.
 * The UI lives in <SchedulingFlow>; this page just supplies the patient-uuid API.
 */
const PatientSchedulePage: React.FC = () => {
  const { patientUuid } = useParams<{ patientUuid: string }>();

  const api: SchedulingApi = useMemo(() => ({
    getContext: () => publicService.getScheduleContext(patientUuid!),
    getFirstAvailableMonth: (meetingTypeId, meetingId) =>
      publicService.getFirstAvailableMonth(patientUuid!, meetingTypeId, meetingId),
    getAvailableSlots: (meetingTypeId, from, to, meetingId) =>
      publicService.getAvailableSlots(patientUuid!, meetingTypeId, from, to, meetingId),
    bookMeeting: (data) => publicService.bookMeeting(patientUuid!, data),
    rescheduleMeeting: (meetingId, data) => publicService.rescheduleMeeting(patientUuid!, meetingId, data),
    cancelMeeting: (meetingId, data) => publicService.cancelMeeting(patientUuid!, meetingId, data),
  }), [patientUuid]);

  return <SchedulingFlow api={api} invalidLink={!patientUuid} />;
};

export default PatientSchedulePage;
